import React, { ReactElement, useMemo } from 'react';
import { createPortal } from 'react-dom';
import {
  Backdrop,
  Container,
  Header,
  SquareButton,
  Title,
  Content,
} from './styles';
import { CrossIcon } from '../icons/CrossIcon';
import { OverlayModalContext } from './OverlayModalContext';
import { noop } from '../../../services/noop';

export const Modal = ({
  active,
  title,
  header,
  children,
  onClose,
  className,
  parentRef,
}: ModalProps) => {
  const context = useMemo(
    () => ({
      close: onClose || noop,
    }),
    [onClose],
  );

  return active
    ? createPortal(
        <Backdrop>
          <Container
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            className={className}
          >
            {header || (
              <Header>
                <Title>{title}</Title>
                <SquareButton onClick={onClose}>
                  <CrossIcon />
                </SquareButton>
              </Header>
            )}
            <Content className="content">
              <OverlayModalContext.Provider value={context}>
                {children}
              </OverlayModalContext.Provider>
            </Content>
          </Container>
        </Backdrop>,
        parentRef?.current || document.body,
      )
    : null;
};

export interface ModalProps {
  title?: string;
  header?: ReactElement;
  active: boolean;
  className?: string;
  children: ReactElement;
  parentRef?: React.MutableRefObject<any>;
  onClose?: () => void;
}
